/**
 * AracWebshop Top Navigation Loading Bar & Storefront PJAX Navigation
 */
(function() {
	if (window.aracStorefrontPjaxLoaded) return;
	window.aracStorefrontPjaxLoaded = true;

	let progress = 0;
	let timer = null;
	let finishTimer = null;
	let resetTimer = null;
	let activeRequest = null;
	let ajaxInProgress = false;
	let productReturnScrollFrame = null;
	let currentPageKey = getUrlKey(window.location);
	const scrollPositions = {};
	const rootSelector = "[data-arac-pjax-root]";
	const pageMarkerSelector = [
		"[data-arac-pjax-page]",
		".arac-home-wrapper",
		".all-products-content",
		".item-page-shell",
		".item-group-page-shell",
		".campaign-landing-container",
		".shop-by-category-wrapper"
	].join(",");
	const productCardSelector = [
		".item-card[data-item-code]",
		".product-card[data-item-code]",
		".arac-product-card[data-item-code]"
	].join(",");
	const productReturnStoragePrefix = "arac_product_return:";
	const productReturnMaxAge = 30 * 60 * 1000;

	function getThemeColor() {
		if (window.ARAC_PRIMARY_COLOR && window.ARAC_PRIMARY_COLOR.length > 0) {
			return window.ARAC_PRIMARY_COLOR;
		}
		try {
			const primary = getComputedStyle(document.documentElement).getPropertyValue("--primary-color").trim();
			if (primary && primary.length > 0 && !primary.includes("initial")) return primary;
		} catch (e) {}
		return "#449CF0";
	}

	function createProgressBar() {
		let $container = $("#top-nav-progress-bar");
		if ($container.length) return $container;

		const color = getThemeColor();
		const html = `
			<div id="top-nav-progress-bar" style="position: fixed; top: 0; left: 0; right: 0; height: 3px; z-index: 9999999; pointer-events: none; opacity: 0; transition: opacity 0.25s ease;">
				<div class="bar-fill" style="height: 100%; width: 0%; background-color: ${color} !important; transition: width 0.22s ease-out; box-shadow: 0 0 10px ${color}, 0 0 5px ${color} !important;"></div>
			</div>
		`;
		$("body").append(html);
		return $("#top-nav-progress-bar");
	}

	const TopLoader = {
		start() {
			// Auth pages have their own submit-button feedback and hash routing.
			// Never paint a navigation bar on an already displayed login form.
			if (isAuthPage() || timer !== null) return;
			clearTimeout(finishTimer);
			clearTimeout(resetTimer);
			finishTimer = resetTimer = null;
			const $container = createProgressBar();
			const $bar = $container.find(".bar-fill");
			const color = getThemeColor();

			$bar.attr(
				"style",
				`height: 100%; width: ${Math.max(progress, 8)}%; background-color: ${color} !important; transition: width 0.22s ease-out; box-shadow: 0 0 10px ${color}, 0 0 5px ${color} !important;`
			);

			progress = Math.max(progress, 8);
			$container.css("opacity", "1");

			timer = setInterval(() => {
				if (progress < 45) {
					progress += Math.random() * 8 + 4;
				} else if (progress < 75) {
					progress += Math.random() * 4 + 1.5;
				} else if (progress < 92) {
					progress += Math.random() * 1.5 + 0.2;
				}
				$bar.css("width", Math.min(progress, 94) + "%");
			}, 180);
		},

		done() {
			if (timer === null) return;
			clearInterval(timer);
			timer = null;
			progress = 0;
			const $container = $("#top-nav-progress-bar");
			if (!$container.length) return;

			const $bar = $container.find(".bar-fill");
			$bar.css("width", "100%");

			finishTimer = setTimeout(() => {
				finishTimer = null;
				$container.css("opacity", "0");
				resetTimer = setTimeout(() => {
					resetTimer = null;
					$bar.css("width", "0%");
				}, 280);
			}, 180);
		}
	};

	window.AracTopLoader = TopLoader;

	// Login owns its hash routing and failed-login feedback. Do not attach
	// storefront history handlers or run storefront initialization on auth pages.
	if (isAuthPage()) return;

	function finishLoaderWhenIdle() {
		if (!activeRequest && !ajaxInProgress) {
			TopLoader.done();
		}
	}

	function markFullNavigation() {
		try {
			sessionStorage.setItem("arac_navigating", "true");
		} catch (e) {}
	}

	// Frappe calls use jQuery AJAX. Keep the navigation line active for cart,
	// pricing, filters, and other storefront requests just as it was before PJAX.
	$(document)
		.off("ajaxStart.arac_top_loader ajaxStop.arac_top_loader")
		.on("ajaxStart.arac_top_loader", function() {
			ajaxInProgress = true;
			TopLoader.start();
		})
		.on("ajaxStop.arac_top_loader", function() {
			ajaxInProgress = false;
			finishLoaderWhenIdle();
		});

	function normalizeUrl(value) {
		try {
			return new URL(value, window.location.origin);
		} catch (e) {
			return null;
		}
	}

	function getUrlKey(url) {
		return url.pathname + url.search;
	}

	function getProductCard(node) {
		if (!node) return null;
		if (node.matches && node.matches(productCardSelector)) return node;
		return node.closest ? node.closest(productCardSelector) : null;
	}

	function getProductCardRoute(card, fallbackUrl) {
		const value = card && card.getAttribute ? card.getAttribute("data-route") : null;
		const route = normalizeUrl(value || (fallbackUrl && fallbackUrl.href));
		return route ? getUrlKey(route) : "";
	}

	function getMatchingProductCards(record) {
		return Array.from(document.querySelectorAll(productCardSelector)).filter((card) => {
			const itemCode = String(card.getAttribute("data-item-code") || "");
			const routeKey = getProductCardRoute(card);
			return itemCode === record.item_code
				&& (!record.route_key || !routeKey || routeKey === record.route_key);
		});
	}

	function rememberProductReturn(node, destinationUrl) {
		const card = getProductCard(node);
		if (!card || !destinationUrl) return false;

		const itemCode = String(card.getAttribute("data-item-code") || "");
		if (!itemCode) return false;

		const destinationKey = getUrlKey(destinationUrl);
		const cardRouteKey = getProductCardRoute(card, destinationUrl);
		// A campaign or badge link can live inside a product card. Only remember
		// navigation to the product represented by the card itself.
		if (cardRouteKey && cardRouteKey !== destinationKey) return false;

		const sourceUrl = normalizeUrl(window.location.href);
		if (!sourceUrl) return false;
		const sourceKey = getUrlKey(sourceUrl);
		const matchingCards = getMatchingProductCards({
			item_code: itemCode,
			route_key: cardRouteKey
		});
		const occurrence = Math.max(0, matchingCards.indexOf(card));
		const record = {
			source_key: sourceKey,
			destination_key: destinationKey,
			item_code: itemCode,
			route_key: cardRouteKey,
			occurrence,
			saved_at: Date.now()
		};

		try {
			sessionStorage.setItem(productReturnStoragePrefix + sourceKey, JSON.stringify(record));
			return true;
		} catch (e) {
			return false;
		}
	}

	function getProductReturnRecord(url, returnFromKey) {
		const sourceKey = getUrlKey(url);
		try {
			const raw = sessionStorage.getItem(productReturnStoragePrefix + sourceKey);
			if (!raw) return null;
			const record = JSON.parse(raw);
			if (!record || record.source_key !== sourceKey || !record.item_code) return null;
			if (Date.now() - Number(record.saved_at || 0) > productReturnMaxAge) {
				sessionStorage.removeItem(productReturnStoragePrefix + sourceKey);
				return null;
			}
			if (returnFromKey && record.destination_key !== returnFromKey) return null;
			return record;
		} catch (e) {
			return null;
		}
	}

	function findProductReturnCard(record) {
		const cards = getMatchingProductCards(record);
		return cards[record.occurrence] || cards[0] || null;
	}

	function animateProductReturnScroll(targetY, reduceMotion) {
		if (productReturnScrollFrame !== null && window.cancelAnimationFrame) {
			window.cancelAnimationFrame(productReturnScrollFrame);
			productReturnScrollFrame = null;
		}

		const startX = window.scrollX || 0;
		const startY = window.scrollY || 0;
		const distance = targetY - startY;
		if (reduceMotion || Math.abs(distance) < 2 || !window.requestAnimationFrame) {
			window.scrollTo(startX, targetY);
			return 0;
		}

		const duration = 320;
		const startedAt = window.performance && window.performance.now
			? window.performance.now()
			: Date.now();
		const step = (timestamp) => {
			const elapsed = Math.max(0, timestamp - startedAt);
			const progress = Math.min(1, elapsed / duration);
			const eased = progress < 0.5
				? 4 * progress * progress * progress
				: 1 - Math.pow(-2 * progress + 2, 3) / 2;
			window.scrollTo(startX, startY + distance * eased);
			if (progress < 1) {
				productReturnScrollFrame = window.requestAnimationFrame(step);
			} else {
				productReturnScrollFrame = null;
			}
		};

		productReturnScrollFrame = window.requestAnimationFrame(step);
		return duration;
	}

	function restoreProductReturn(url, returnFromKey) {
		const record = getProductReturnRecord(url, returnFromKey);
		if (!record) return false;

		let attemptCount = 0;
		const maxAttempts = 24;
		const tryRestore = () => {
			const currentUrl = normalizeUrl(window.location.href);
			if (!currentUrl || getUrlKey(currentUrl) !== record.source_key) return;
			const card = findProductReturnCard(record);
			if (!card) {
				attemptCount += 1;
				if (attemptCount < maxAttempts) setTimeout(tryRestore, 100);
				return;
			}

			const rect = card.getBoundingClientRect();
			const visibleTop = Math.min(170, Math.max(24, window.innerHeight * 0.2));
			const isComfortablyVisible = rect.top >= visibleTop && rect.bottom <= window.innerHeight - 24;
			const reduceMotion = window.matchMedia
				&& window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			let scrollDuration = 0;
			if (!isComfortablyVisible) {
				const targetY = Math.max(
					0,
					(window.scrollY || 0) + rect.top - Math.max(0, (window.innerHeight - rect.height) / 2)
				);
				scrollDuration = animateProductReturnScroll(targetY, reduceMotion);
			}

			const highlightDelay = scrollDuration ? Math.max(0, scrollDuration - 40) : 0;
			setTimeout(() => {
				card.classList.remove("arac-product-return-focus");
				void card.offsetWidth;
				card.classList.add("arac-product-return-focus");
				setTimeout(() => card.classList.remove("arac-product-return-focus"), 1100);
			}, highlightDelay);
		};

		setTimeout(tryRestore, 40);
		return true;
	}

	function isBackForwardNavigation(event) {
		if (event && event.persisted) return true;
		try {
			const entry = window.performance && window.performance.getEntriesByType
				? window.performance.getEntriesByType("navigation")[0]
				: null;
			if (entry && entry.type === "back_forward") return true;
			return Boolean(window.performance && window.performance.navigation
				&& window.performance.navigation.type === 2);
		} catch (e) {
			return false;
		}
	}

	function isAuthPage() {
		const path = window.location.pathname.replace(/\/+$/, "");
		return document.documentElement.classList.contains("arac-auth-page") || [
			"/login", "/logout", "/signup", "/forgot-password", "/reset-password",
			"/update-password", "/update_password", "/complete_signup", "/complete-signup",
			"/verify", "/verify-email", "/verify-email-link", "/set-password"
		].includes(path);
	}

	function isCurrentStorefrontPage() {
		const root = document.querySelector(rootSelector) || document.querySelector(".page-content-wrapper");
		return !!(root && root.querySelector(pageMarkerSelector));
	}

	function isDeniedPath(pathname) {
		const path = (pathname || "/").replace(/\/+$/, "") || "/";
		const deniedExact = [
			"/login",
			"/logout",
			"/signup",
			"/forgot-password",
			"/reset-password",
			"/update-password",
			"/update_password",
			"/complete_signup",
			"/complete-signup",
			"/cart",
			"/checkout",
			"/wishlist",
			"/orders",
			"/invoices",
			"/me",
			"/update-profile",
			"/customer_reviews",
			"/product-post-designer"
		];
		const deniedPrefixes = [
			"/app",
			"/desk",
			"/api",
			"/assets",
			"/files",
			"/private",
			"/printview",
			"/address",
			"/addresses",
			"/account",
			"/profile",
			"/issues",
			"/payments",
			"/payment",
			"/integrations"
		];

		if (deniedExact.includes(path)) return true;
		return deniedPrefixes.some((prefix) => path === prefix || path.startsWith(prefix + "/"));
	}

	function looksLikeDownload(pathname) {
		return /\.(?:pdf|docx?|xlsx?|csv|tsv|zip|rar|7z|jpg|jpeg|png|gif|webp|svg|mp4|mov|webm|mp3|wav)(?:$|\?)/i.test(pathname || "");
	}

	function isKnownStorefrontPath(pathname) {
		const path = (pathname || "/").replace(/\/+$/, "") || "/";
		if (path === "/" || path === "/shop-home" || path === "/all-products" || path === "/shop-by-category") {
			return true;
		}
		return [
			"/campaign",
			"/deals",
			"/deal",
			"/brand",
			"/brands",
			"/category",
			"/categories",
			"/item-group",
			"/products",
			"/product"
		].some((prefix) => path === prefix || path.startsWith(prefix + "/"));
	}

	function hasStorefrontLinkContext(anchor) {
		return !!(
			anchor &&
			anchor.closest([
				"#arac-navbar",
				"#arac-category-navbar",
				"#mobile-bottom-nav",
				".arac-home-wrapper",
				".all-products-content",
				".item-page-shell",
				".item-group-page-shell",
				".campaign-landing-container",
				".shop-by-category-wrapper",
				".item-card",
				".product-card",
				".arac-product-card",
				".category-card",
				".subcategory-card",
				".sub-category-pill",
				".campaign-card",
				".arac-campaign-card-size",
				".more-from-group-section",
				".fbt-section"
			].join(","))
		);
	}

	function hasRiskyQuery(url) {
		const params = url.searchParams;
		return ["cmd", "method", "action", "_method", "download", "format", "file"].some((key) => params.has(key));
	}

	function shouldIgnoreLinkEvent(event, anchor) {
		if (!anchor) return true;
		if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented)) return true;
		if (anchor.target && anchor.target !== "_self") return true;
		if (anchor.hasAttribute("download")) return true;
		if (anchor.closest("form, [data-no-pjax], .no-pjax")) return true;
		if (anchor.getAttribute("data-method") || anchor.getAttribute("data-action")) return true;
		if (anchor.getAttribute("onclick")) return true;
		return false;
	}

	function canTryPjax(url, anchor) {
		if (!url) return false;
		if (!("fetch" in window) || !("DOMParser" in window) || !window.history || !history.pushState) return false;
		if (url.origin !== window.location.origin) return false;
		if (!["http:", "https:"].includes(url.protocol)) return false;
		if (isDeniedPath(url.pathname) || looksLikeDownload(url.pathname) || hasRiskyQuery(url)) return false;
		if (url.hash && getUrlKey(url) === getUrlKey(window.location)) return false;
		if (!isCurrentStorefrontPage()) return false;
		if (url.pathname === window.location.pathname) return true;
		return isKnownStorefrontPath(url.pathname) || hasStorefrontLinkContext(anchor);
	}

	function getCompatibleRoot(doc) {
		const wrapper = doc.querySelector(".page-content-wrapper");
		const root = doc.querySelector(rootSelector) || (wrapper ? wrapper.parentElement : null);
		if (!root) return null;
		if (!root.querySelector(pageMarkerSelector)) return null;
		if (root.querySelector("form:not([data-arac-pjax-safe-form])")) return null;
		if (doc.body && /(?:login|cart|checkout|web-form|portal-layout)/i.test(doc.body.className || "")) return null;
		return root;
	}

	function saveScrollPosition() {
		const url = normalizeUrl(window.location.href);
		if (!url) return;
		const position = { x: window.scrollX || 0, y: window.scrollY || 0 };
		scrollPositions[getUrlKey(url)] = position;
		try {
			sessionStorage.setItem("arac_pjax_scroll:" + getUrlKey(url), JSON.stringify(position));
		} catch (e) {}
	}

	function getSavedScrollPosition(url) {
		const key = getUrlKey(url);
		if (scrollPositions[key]) return scrollPositions[key];
		try {
			const saved = sessionStorage.getItem("arac_pjax_scroll:" + key);
			if (saved) return JSON.parse(saved);
		} catch (e) {}
		return null;
	}

	function restoreScroll(url, mode) {
		const saved = mode === "restore" ? getSavedScrollPosition(url) : null;
		const x = saved ? saved.x || 0 : 0;
		const y = saved ? saved.y || 0 : 0;
		requestAnimationFrame(() => window.scrollTo(x, y));
	}

	function updateBodyAndHtml(doc) {
		const nextBody = doc.body;
		if (nextBody) {
			const transient = [
				"mobile-drawer-open",
				"modal-open",
				"arac-variant-picker-open",
				"arac-branch-modal-open"
			];
			document.body.className = nextBody.className || "";
			transient.forEach((className) => document.body.classList.remove(className));

			Array.from(document.body.attributes).forEach((attr) => {
				if (attr.name !== "class") document.body.removeAttribute(attr.name);
			});
			Array.from(nextBody.attributes).forEach((attr) => {
				if (attr.name !== "class") document.body.setAttribute(attr.name, attr.value);
			});
			document.body.style.overflow = "";
		}

		const nextHtml = doc.documentElement;
		if (nextHtml) {
			if (nextHtml.getAttribute("lang")) {
				document.documentElement.setAttribute("lang", nextHtml.getAttribute("lang"));
			}
			if (nextHtml.getAttribute("dir")) {
				document.documentElement.setAttribute("dir", nextHtml.getAttribute("dir"));
			}
		}
	}

	function updateTitleAndMeta(doc) {
		if (doc.title) document.title = doc.title;

		const nextDescription = doc.head && doc.head.querySelector('meta[name="description"]');
		const currentDescription = document.head.querySelector('meta[name="description"]');
		if (nextDescription && currentDescription) {
			currentDescription.setAttribute("content", nextDescription.getAttribute("content") || "");
		} else if (nextDescription && !currentDescription) {
			document.head.appendChild(nextDescription.cloneNode(true));
		}
	}

	function updatePjaxHead(doc) {
		document.querySelectorAll("[data-arac-pjax-head]").forEach((node) => node.remove());
		if (!doc.head) return;

		const existingStyleText = Array.from(document.head.querySelectorAll("style:not([data-arac-pjax-head])"))
			.map((style) => (style.textContent || "").trim())
			.filter(Boolean);

		doc.head.querySelectorAll("style").forEach((style) => {
			const text = (style.textContent || "").trim();
			if (!text || existingStyleText.includes(text)) return;
			const clone = style.cloneNode(true);
			clone.setAttribute("data-arac-pjax-head", "1");
			document.head.appendChild(clone);
		});
	}

	function cleanupBeforeSwap() {
		saveScrollPosition();
		if (productReturnScrollFrame !== null && window.cancelAnimationFrame) {
			window.cancelAnimationFrame(productReturnScrollFrame);
			productReturnScrollFrame = null;
		}
		try {
			[
				"aracGalleryPreviewCleanup",
				"aracCampaignPageCleanup",
				"aracHomeCampaignCleanup",
				"aracHomeHeroCleanup",
				"aracShopByCategoryCleanup",
				"aracItemGroupCleanup"
			].forEach((name) => {
				if (typeof window[name] === "function") {
					window[name]();
					window[name] = null;
				}
			});
		} catch (e) {
			console.warn("[Arac PJAX] Page cleanup failed", e);
		}

		try {
			$(window).off(".product_listing .product_filter_shell .item_group_filters .item_group_subcategories");
			$(document).off(".product_filter_shell .item_detail_cart .item_reviews .all_products_filters .item_group_filters .branch_availability .branch_availability_refresh");
			$(".image-zoom-view, .arac-promo-modal, .arac-variant-picker-overlay").remove();
			$("#freeze, #ez-freeze-box, #ez-freeze-style").remove();
			$("body").removeClass("mobile-drawer-open modal-open arac-variant-picker-open arac-branch-modal-open");
			$("body").css("overflow", "");
		} catch (e) {}
	}

	function isRunnableScript(script) {
		const type = (script.getAttribute("type") || "text/javascript").toLowerCase();
		if (type && !["text/javascript", "application/javascript", "module"].includes(type)) return false;
		if (!script.src && /document\.write\s*\(/.test(script.textContent || "")) return false;
		return true;
	}

	function isAllowedExternalScript(script) {
		if (!script.src) return true;
		const url = normalizeUrl(script.src);
		if (!url || url.origin !== window.location.origin) return false;
		const src = url.pathname;
		if (/jquery|frappe-web|controls|dialog|bootstrap|web\.bundle|aracwebshop-web\.bundle/i.test(src)) {
			return false;
		}
		return (
			src === "/shop-by-category/index.js" ||
			src === "/all-products/index.js" ||
			src === "/assets/aracwebshop/js/product_listing.js"
		);
	}

	function executeScript(original) {
		return new Promise((resolve) => {
			if (!isRunnableScript(original) || !isAllowedExternalScript(original)) {
				original.remove();
				resolve();
				return;
			}

			if (original.src) {
				const existing = document.querySelector(`script[data-arac-pjax-src="${original.src}"], script[src="${original.src}"]`);
				if (existing && existing !== original) {
					original.remove();
					resolve();
					return;
				}
			}

			const script = document.createElement("script");
			Array.from(original.attributes).forEach((attr) => {
				script.setAttribute(attr.name, attr.value);
			});
			script.setAttribute("data-arac-pjax-executed", "1");
			if (original.src) {
				script.setAttribute("data-arac-pjax-src", original.src);
				script.onload = () => resolve();
				script.onerror = () => resolve();
			} else {
				script.textContent = original.textContent || "";
			}
			original.replaceWith(script);
			if (!original.src) resolve();
		});
	}

	function collectExternalPageScripts(doc) {
		return Array.from(doc.body ? doc.body.querySelectorAll("script[src]") : [])
			.filter(isAllowedExternalScript);
	}

	function updateNavbarState() {
		const path = window.location.pathname;
		let activeTab = "";

		if (path === "/" || path === "/shop-home") {
			activeTab = "home";
		} else if (path === "/shop-by-category") {
			activeTab = "categories";
		} else if (path.startsWith("/all-products")) {
			activeTab = "search";
		} else if (path === "/cart") {
			activeTab = "cart";
		} else if (path === "/me" || path === "/orders" || path === "/invoices" || path.startsWith("/orders/") || path.startsWith("/invoices/")) {
			activeTab = "profile";
		}

		$("#mobile-bottom-nav .mobile-nav-item").removeClass("active");
		if (activeTab) {
			$(`#mobile-bottom-nav .mobile-nav-item[data-path="${activeTab}"]`).addClass("active");
		}

		const queryParams = typeof frappe !== "undefined" && frappe.utils && frappe.utils.get_query_params ? frappe.utils.get_query_params() : {};
		const searchTerm = ((queryParams.search || queryParams.search_term || "") + "").trim();
		$("#search-box, #search-box-mobile").val(searchTerm);
	}

	function bindItemDetailCartControls() {
		try {
			if (!$(".item-cart .product-qty-input").length) return;

			const message = (text, args) => {
				if (typeof __ === "function") return __(text, args);
				return text;
			};

			const getCart = ($node) => {
				const $cart = $node.closest(".item-cart");
				return $cart.length ? $cart : $(".item-cart").first();
			};

			const getActiveUom = ($cart) => {
				const $activeUom = $cart.find(".uom-btn.active");
				if ($activeUom.length) {
					return {
						uom: $activeUom.attr("data-uom") || null,
						conversion_factor: parseFloat($activeUom.attr("data-conversion")) || null
					};
				}
				return {
					uom: $cart.attr("data-active-uom") || null,
					conversion_factor: parseFloat($cart.attr("data-active-conversion")) || null
				};
			};

			const getQtyInput = ($cart) => $cart.find(".product-qty-input").first();

			const validateQty = ($input, requestedQty) => {
				const $cart = getCart($input);
				const maxQty = parseFloat($cart.attr("data-max-qty-per-order")) || 0;
				const projectedQty = parseFloat($cart.attr("data-projected-qty")) || 0;
				const allowItemsNotInStock = parseInt($cart.attr("data-allow-items-not-in-stock"), 10) || 0;
				const { conversion_factor } = getActiveUom($cart);
				const conversion = conversion_factor || 1;
				const requestedStockQty = requestedQty * conversion;
				let qty = requestedQty;

				if (maxQty > 0 && requestedStockQty > maxQty) {
					const maxInUom = Math.floor(maxQty / conversion) || 1;
					if (typeof frappe !== "undefined" && frappe.msgprint) {
						frappe.msgprint(message("You only can order {0} of this item.", [maxInUom]));
					}
					qty = maxInUom;
				}

				if (!allowItemsNotInStock && requestedStockQty > projectedQty) {
					const projectedInUom = Math.floor(projectedQty / conversion);
					if (projectedInUom <= 0) {
						if (typeof frappe !== "undefined" && frappe.msgprint) {
							frappe.msgprint(message("This item is currently out of stock."));
						}
						qty = 1;
					} else {
						if (typeof frappe !== "undefined" && frappe.msgprint) {
							frappe.msgprint(message("Only {0} available in stock.", [projectedInUom]));
						}
						qty = projectedInUom;
					}
				}

				$input.val(qty);
				const cartQty = parseInt($input.attr("data-cart-qty") || $input.data("cart-qty"), 10) || 0;
				if (cartQty > 0) {
					if (qty !== cartQty) {
						$cart.find(".btn-add-to-cart").removeClass("hidden");
						$cart.find(".btn-go-to-cart").addClass("hidden");
					} else {
						$cart.find(".btn-add-to-cart").addClass("hidden");
						$cart.find(".btn-go-to-cart").removeClass("hidden");
					}
				}
				return qty;
			};

			$(document)
				.off("click.item_detail_cart", ".qty-btn-minus")
				.on("click.item_detail_cart", ".qty-btn-minus", function(event) {
					const $btn = $(this);
					const $cart = getCart($btn);
					if (!$cart.length || $btn.closest(".qty-selector").hasClass("pointer-events-none")) return;
					event.preventDefault();
					const $input = getQtyInput($cart);
					let qty = parseInt($input.val(), 10) || 1;
					if (qty > 1) {
						qty -= 1;
						$input.val(qty);
						validateQty($input, qty);
					}
				});

			$(document)
				.off("click.item_detail_cart", ".qty-btn-plus")
				.on("click.item_detail_cart", ".qty-btn-plus", function(event) {
					const $btn = $(this);
					const $cart = getCart($btn);
					if (!$cart.length || $btn.closest(".qty-selector").hasClass("pointer-events-none")) return;
					event.preventDefault();
					const $input = getQtyInput($cart);
					let qty = parseInt($input.val(), 10) || 1;
					qty += 1;
					$input.val(qty);
					validateQty($input, qty);
				});

			$(document)
				.off("change.item_detail_cart input.item_detail_cart", ".product-qty-input")
				.on("change.item_detail_cart input.item_detail_cart", ".product-qty-input", function() {
					const $input = $(this);
					if (!$input.closest(".item-cart").length) return;
					let qty = parseInt($input.val(), 10) || 1;
					if (qty < 1) qty = 1;
					$input.val(qty);
					validateQty($input, qty);
				});

			$(document)
				.off("click.item_detail_cart", ".btn-add-to-cart")
				.on("click.item_detail_cart", ".btn-add-to-cart", function(event) {
					const $btn = $(this);
					const $cart = getCart($btn);
					if (!$cart.length) return;
					if ($btn.prop("disabled") || $btn.hasClass("pointer-events-none")) return;
					event.preventDefault();

					const cart = window.aracwebshop && aracwebshop.aracwebshop && aracwebshop.aracwebshop.shopping_cart;
					if (!cart || !cart.update_cart) return;

					const $allBtns = $cart.find(".btn-add-to-cart");
					const itemCode = $btn.attr("data-item-code") || $cart.attr("data-variant-item-code");
					const { uom, conversion_factor } = getActiveUom($cart);
					const $qtyInput = getQtyInput($cart);
					const qty = validateQty($qtyInput, parseInt($qtyInput.val(), 10) || 1);
					const warehouse = $cart.attr("data-selected-warehouse") || null;
					if (!itemCode) return;

					$allBtns.prop("disabled", true);
					cart.update_cart({
						item_code: itemCode,
						qty: qty,
						uom: uom,
						conversion_factor: conversion_factor,
						warehouse: warehouse,
						$trigger: $btn,
						callback(r) {
							$allBtns.prop("disabled", false);
							const msg = r.message || {};
							if (!r.exc && msg.status !== "error") {
								$qtyInput.data("cart-qty", qty).attr("data-cart-qty", qty);
								const $activeBtn = $cart.find(`.uom-btn[data-uom="${uom || 'Nos'}"]`);
								if ($activeBtn.length) {
									$activeBtn.attr("data-cart-qty", qty);
								}
								$(document).trigger("arac_variant_cart_qty_changed", [{ item_code: itemCode, qty }]);
								$cart.find(".btn-add-to-cart").addClass("hidden");
								$cart.find(".btn-go-to-cart").removeClass("hidden");
								$cart.find(".btn-view-in-cart").addClass("hidden");
								if (cart.show_add_to_cart_toast) {
									cart.show_add_to_cart_toast({ item_code: itemCode, $trigger: $btn });
								}
							} else {
								const currentQty = parseInt(msg.current_qty, 10) || 0;
								const resetQty = currentQty > 0 ? currentQty : 1;
								$qtyInput.val(resetQty);
								validateQty($qtyInput, resetQty);
							}
						},
						error() {
							$allBtns.prop("disabled", false);
						}
					});
				});
		} catch (e) {
			console.warn("[Arac PJAX] Item detail cart binding failed", e);
		}
	}

	function refreshStorefrontState() {
		try {
			if (window.aracSyncHeaderHeight) window.aracSyncHeaderHeight();
			updateNavbarState();
			bindItemDetailCartControls();

			const cart = window.aracwebshop && aracwebshop.aracwebshop && aracwebshop.aracwebshop.shopping_cart;
			if (cart) {
				if (cart.set_cart_count) cart.set_cart_count();
				if (cart.bind_add_to_cart_action) cart.bind_add_to_cart_action();
			}

			const wishlist = window.aracwebshop && aracwebshop.aracwebshop && aracwebshop.aracwebshop.wishlist;
			if (wishlist) {
				if (wishlist.set_wishlist_count) wishlist.set_wishlist_count();
				if (wishlist.bind_wishlist_action) wishlist.bind_wishlist_action();
			}

			if (typeof window.aracEnsureVariantPickerForPage === "function") {
				window.aracEnsureVariantPickerForPage(document);
			} else if (window.aracwebshop && aracwebshop.aracwebshop && aracwebshop.aracwebshop.variant_picker) {
				aracwebshop.aracwebshop.variant_picker.init();
			}

			if (window.aracwebshop && typeof aracwebshop.init_product_listing === "function") {
				aracwebshop.init_product_listing();
			}

			const currentSearch = window._arac_product_search_inited;
			const searchDropdown = currentSearch && currentSearch.search_dropdown && currentSearch.search_dropdown[0];
			if (
				window.aracwebshop &&
				aracwebshop.ProductSearch &&
				$("#search-box, #search-box-mobile").length &&
				(!currentSearch || !searchDropdown || !document.body.contains(searchDropdown))
			) {
				window._arac_product_search_inited = new aracwebshop.ProductSearch();
			}

			if (document.querySelector(".shop-by-category-wrapper")) {
				if (window.aracwebshop && typeof aracwebshop.init_shop_by_category === "function") {
					aracwebshop.init_shop_by_category();
				} else {
					loadPageScript("/shop-by-category/index.js").then(() => {
						if (window.aracwebshop && typeof aracwebshop.init_shop_by_category === "function") {
							aracwebshop.init_shop_by_category();
						}
					});
				}
			}

			if (document.querySelector(".arac-home-wrapper") && typeof window.aracInitHomePage === "function") {
				window.aracInitHomePage(document);
			}

			initInlineVariantSelector();
			setTimeout(initInlineVariantSelector, 80);

			document.dispatchEvent(new CustomEvent("arac:pjax:load", {
				detail: {
					url: window.location.href,
					container: document.querySelector(rootSelector)
				}
			}));
		} catch (e) {
			console.warn("[Arac PJAX] Post-swap initialization failed", e);
		}
	}

	function disableInlineVariantCartControls() {
		try {
			if (!$(".inline-variant-selector").length) return;
			$(".btn-view-in-cart, .btn-go-to-cart").addClass("hidden");
			$(".product-qty-input").val(1).data("cart-qty", 0).attr("data-cart-qty", 0);
			$(".qty-selector").addClass("opacity-50 pointer-events-none");
			const label = typeof __ === "function" ? __("Select Options") : "Select Options";
			$(".btn-add-to-cart").each((idx, elem) => {
				const $btn = $(elem);
				$btn.removeClass("hidden")
					.prop("disabled", true)
					.addClass("opacity-60 pointer-events-none");
				$btn.find("span").text(label);
			});
		} catch (e) {}
	}

	function initInlineVariantSelector() {
		try {
			const $selectors = $(".inline-variant-selector");
			if (!$selectors.length) return;

			const $pendingSelectors = $selectors.filter((idx, elem) => {
				return $(elem).attr("data-inline-configure-initialized") !== "1";
			});
			if (!$pendingSelectors.length) return;

			disableInlineVariantCartControls();

			if (typeof window.aracInitInlineItemConfigure === "function") {
				window.aracInitInlineItemConfigure(document);
				return;
			}

			if (typeof window.InlineItemConfigure !== "function") {
				return;
			}

			$pendingSelectors.each((idx, elem) => {
				const $selector = $(elem);
				$selector.attr("data-inline-configure-initialized", "1");
				new window.InlineItemConfigure($selector);
			});
		} catch (e) {
			console.warn("[Arac PJAX] Inline variant initialization failed", e);
		}
	}

	function loadPageScript(src) {
		return new Promise((resolve) => {
			const existing = document.querySelector(`script[data-arac-pjax-src="${src}"], script[src="${src}"]`);
			if (existing) {
				resolve();
				return;
			}
			const script = document.createElement("script");
			script.src = src;
			script.async = false;
			script.setAttribute("data-arac-pjax-src", src);
			script.onload = () => resolve();
			script.onerror = () => resolve();
			document.body.appendChild(script);
		});
	}

	async function swapPage(doc, url, options) {
		const currentRoot = document.querySelector(rootSelector);
		const nextRoot = getCompatibleRoot(doc);
		if (!currentRoot || !nextRoot) return false;

		const externalScripts = collectExternalPageScripts(doc);
		cleanupBeforeSwap();
		updateTitleAndMeta(doc);
		updatePjaxHead(doc);
		updateBodyAndHtml(doc);

		const importedRoot = document.importNode(nextRoot, true);
		currentRoot.replaceWith(importedRoot);
		currentPageKey = getUrlKey(url);

		for (const script of Array.from(importedRoot.querySelectorAll("script"))) {
			await executeScript(script);
		}

		for (const script of externalScripts) {
			await loadPageScript(script.getAttribute("src"));
		}

		refreshStorefrontState();
		restoreScroll(url, options.scrollMode || "top");
		if ((options.scrollMode || "top") === "restore") {
			restoreProductReturn(url, options.returnFromKey || null);
		}
		return true;
	}

	async function fetchAndSwap(url, options) {
		if (activeRequest) activeRequest.abort();
		const request = new AbortController();
		activeRequest = request;

		TopLoader.start();

		try {
			const response = await fetch(url.href, {
				method: "GET",
				credentials: "same-origin",
				headers: {
					"Accept": "text/html,application/xhtml+xml",
					"X-Arac-PJAX": "1"
				},
				signal: request.signal
			});

			if (!response.ok) return false;
			const contentType = response.headers.get("content-type") || "";
			if (!contentType.includes("text/html")) return false;

			const html = await response.text();
			const doc = new DOMParser().parseFromString(html, "text/html");
			const finalUrl = normalizeUrl(response.url || url.href) || url;

			if (isDeniedPath(finalUrl.pathname) || !getCompatibleRoot(doc)) {
				return false;
			}

			if (options.push !== false) {
				history.pushState({ __arac_pjax: true, url: finalUrl.href }, "", finalUrl.href);
			}

			return await swapPage(doc, finalUrl, options);
		} catch (e) {
			if (e && e.name === "AbortError") return true;
			console.warn("[Arac PJAX] Navigation failed", e);
			return false;
		} finally {
			// An aborted, older navigation must not finish the new page's loader.
			if (activeRequest === request) {
				activeRequest = null;
				finishLoaderWhenIdle();
			}
		}
	}

	function hardNavigate(url) {
		markFullNavigation();
		window.location.href = url.href;
	}

	function navigate(value, options) {
		const url = normalizeUrl(value);
		options = options || {};
		if (url && options.anchor) {
			rememberProductReturn(options.anchor, url);
		}
		if (!canTryPjax(url, options.anchor || null)) {
			if (options.fallback !== false && url) hardNavigate(url);
			return Promise.resolve(false);
		}

		return fetchAndSwap(url, options).then((handled) => {
			if (!handled && options.fallback !== false) {
				hardNavigate(url);
			}
			return handled;
		});
	}

	window.aracPjaxNavigate = function(value, options) {
		return navigate(value, options || {});
	};

	$(document).on("click.arac_pjax", "a[href]", function(event) {
		const anchor = this;
		if (shouldIgnoreLinkEvent(event, anchor)) return;

		const href = anchor.getAttribute("href");
		if (!href || href.startsWith("#") || href.startsWith("javascript:") || href.startsWith("mailto:") || href.startsWith("tel:")) return;

		const url = normalizeUrl(href);
		if (!url) return;
		if (url.origin !== window.location.origin) return;

		const currentKey = window.location.pathname + window.location.search;
		if (getUrlKey(url) === currentKey) return;

		if (!canTryPjax(url, anchor)) {
			// A denied PJAX path still performs a normal browser navigation. Show
			// the line while Cart, Orders, Invoices, Profile, etc. are loading.
			if (!looksLikeDownload(url.pathname)) {
				event.preventDefault();
				TopLoader.start();
				hardNavigate(url);
			}
			return;
		}

		event.preventDefault();
		navigate(url.href, { anchor: anchor, push: true, scrollMode: "top" });
	});

	if (isCurrentStorefrontPage()) {
		if (window.history && "scrollRestoration" in history) {
			history.scrollRestoration = "manual";
		}

		try {
			history.replaceState({ __arac_pjax: true, url: window.location.href }, "", window.location.href);
		} catch (e) {}
	}

	window.addEventListener("popstate", function() {
		const url = normalizeUrl(window.location.href);
		// Login uses hash routing, which also emits popstate. Only fetch a new
		// document when moving between supported storefront pages.
		if (!url || getUrlKey(url) === currentPageKey || !isCurrentStorefrontPage() || isDeniedPath(url.pathname)) return;
		const returnFromKey = currentPageKey;
		fetchAndSwap(url, {
			push: false,
			scrollMode: "restore",
			fallback: true,
			returnFromKey
		}).then((handled) => {
			if (!handled) hardNavigate(url);
		});
	});

	window.addEventListener("beforeunload", saveScrollPosition);

	function onReady() {
		let completingFullNavigation = false;
		try {
			completingFullNavigation = sessionStorage.getItem("arac_navigating") === "true";
			sessionStorage.removeItem("arac_navigating");
		} catch (e) {}

		// Authentication templates clear this marker before the bundle loads.
		// Replaying it here restores the normal destination-page completion line
		// without bringing the loader back to Login or password-recovery pages.
		if (completingFullNavigation) {
			TopLoader.start();
			setTimeout(finishLoaderWhenIdle, 80);
		}
		refreshStorefrontState();
		if (isBackForwardNavigation()) {
			const url = normalizeUrl(window.location.href);
			if (url) restoreProductReturn(url, null);
		}
	}

	if (typeof frappe !== "undefined" && frappe.ready) frappe.ready(onReady);
	else $(document).ready(onReady);

	window.addEventListener("pageshow", function(event) {
		if (event.persisted) {
			TopLoader.done();
			refreshStorefrontState();
			const url = normalizeUrl(window.location.href);
			if (url) restoreProductReturn(url, null);
		}
	});
})();
